module.exports = "<a class=\"common-link\" ng-click=\"actions.onClick($event)\" href='' role=\"button\">\n    <span ng-if=\"props.leftIcon\" class=\"icon left-icon {{props.leftIcon}}\"></span><span>{{props.label}}</span><span ng-if=\"props.rightIcon\" class=\"icon right-icon {{props.rightIcon}}\"></span>\n</a>\n"


//////////////////
// WEBPACK FOOTER
// ../node_modules/xo-ui-components/src/link/template.html
// module id = ../node_modules/xo-ui-components/src/link/template.html
// module chunks = 0